/* tslint:disable */

/**
 */
export class productChart2DStatic {
    temperatureMax?: number;
    refreshTemp?: number;
    idStudyEquipment?: number;
    selectedPlan?: number;
    temperatureStep?: number;
    temperatureMin?: number;
    idStudy?: number;
    timeSelected?: number;
    timeInterval?: number;
    axisX?: number;
    axisY?: number;
    dimension?: string;
}



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/api/models/product-chart-2dstatic.ts